// TODO: Import React module
import React, { useState, useEffect, useCallback } from 'react';

// TODO: Import MUI module
import { Box, Container, IconButton, Stack, Typography, useMediaQuery, useTheme, } from '@mui/material';

// TODO: Import MUI icon
import { Circle, CircleOutlined } from '@mui/icons-material';

// TODO: Import context
//import { Context } from '../../Common/Context';
//import { Text } from '../../Common/Text';

// TODO: Import custom component

const Home = () => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component Home Rendered');

    // TODO: Define useContext
    //const { language } = React.useContext(Context);

    // TODO: Define variable
    const heroSlides = [
        {
            image: 'https://www.pohtyh.edu.hk/Files/CampusDevelopment/BlessedBotanicals/Home/1.jpg',
            title: '愉快的種植活動',
            subtitle: '親手培育生命的喜悅',
            description: '在貽園的種植活動中，師生共同體驗從播種到收成的完整過程。無論是初次接觸園藝的同學還是對種植有研究的教職員，都能體驗真正的生命教育。'
        },
        {
            image: 'https://www.pohtyh.edu.hk/Files/CampusDevelopment/BlessedBotanicals/Home/2.jpg',
            title: '充滿生氣的園圃',
            subtitle: '校園裡的生態熱點',
            description: '貽園四季常青，不只適合多樣化的動植物生長，更是鳥類、昆蟲共生的微型生態圈，完美展現都市中難得一見的自然生命力。',
        },
        {
            image: 'https://www.pohtyh.edu.hk/Files/CampusDevelopment/BlessedBotanicals/Home/3.jpg',
            title: '豐盛的中藥資源',
            subtitle: '傳承千年的文化瑰寶',
            description: '貽園精心培育多種藥用植物，如薄荷、龍脷葉、艾草等，不僅是中醫智慧的見證，更是中學生學習中華文化的天然課堂。這些珍貴的草本資源，讓學生親手觸摸與辨識，將書本中的傳統知識化為實踐，深化中華文化認知，同時培養對自然資源的珍惜之心。',
        },
        {
            image: 'https://www.pohtyh.edu.hk/Files/CampusDevelopment/BlessedBotanicals/Home/4.jpg',
            title: '大自然與科技的結合',
            subtitle: 'STEAM教育融入校園生活',
            description: '貽園結合傳統園藝與現代科技，配備智能灑水系統及濕度監測設備，為學生提供STEAM課程的活教材。學生可親身體驗物聯網技術在農業中的應用，學習數據分析與環境監測，培養跨學科創新能力。',
        }
    ];

    const [currentSlide, setCurrentSlide] = useState(0);
    const [isTransitioning, setIsTransitioning] = useState(false);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    // TODO: Define event
    const handleNext = useCallback(() => {
        setIsTransitioning(true);
        setTimeout(() => {
            setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
            setIsTransitioning(false);
        }, 1000);
    }, [heroSlides.length]);

    const handleDotClick = (index) => {
        if (index !== currentSlide && !isTransitioning) {
            setIsTransitioning(true);
            setTimeout(() => {
                setCurrentSlide(index);
                setIsTransitioning(false);
            }, 1000);
        }
    };

    useEffect(() => {
        const interval = setInterval(() => { handleNext(); }, 6000);
        return () => clearInterval(interval);
    }, [currentSlide, handleNext]);

    // TODO: Return component
    return (
        <Box sx={{
            height: '100vh',
            maxHeight: '480px',
            position: 'relative',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            textAlign: 'center'
        }}>
            {heroSlides.map((slide, index) => (
                <Box
                    key={index}
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundImage: `url(${slide.image})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: index === currentSlide ? 1 : 0,
                        transition: 'opacity 1s ease-in-out',
                        zIndex: 0
                    }}
                />
            ))}
            <Box sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                zIndex: 1
            }} />
            <Container sx={{
                position: 'relative',
                zIndex: 2,
                transition: 'opacity 1s ease-in-out',
                opacity: isTransitioning ? 0 : 1
            }}>
                {heroSlides.map((slide, index) => (
                    <Box
                        key={index}
                        sx={{ display: index === currentSlide ? 'block' : 'none' }}
                    >
                        <Typography
                            variant={isMobile ? 'h5' : 'h2'}
                            gutterBottom
                            sx={{
                                fontWeight: 'bold',
                                animation: index === currentSlide ? 'fadeInUp 1s ease-out' : 'none',
                                '@keyframes fadeInUp': {
                                    '0%': { opacity: 0, transform: 'translateY(20px)' },
                                    '100%': { opacity: 1, transform: 'translateY(0)' }
                                }
                            }}
                        >
                            {slide.title}
                        </Typography>
                        <Typography
                            variant="h5"
                            gutterBottom
                            sx={{
                                animation: index === currentSlide ? 'fadeInUp 1s ease-out 0.2s forwards' : 'none',
                                opacity: 0
                            }}
                        >
                            {slide.subtitle}
                        </Typography>
                        <Typography
                            variant="body1"
                            sx={{
                                maxWidth: '800px',
                                mx: 'auto',
                                mb: 4,
                                animation: index === currentSlide ? 'fadeInUp 1s ease-out 0.4s forwards' : 'none',
                                opacity: 0
                            }}
                        >
                            {slide.description}
                        </Typography>
                    </Box>
                ))}
            </Container>
            <Stack
                direction="row"
                spacing={1}
                sx={{
                    position: 'absolute',
                    bottom: 40,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    zIndex: 3
                }}
            >
                {heroSlides.map((_, index) => (
                    <IconButton
                        key={index}
                        color="inherit"
                        onClick={() => handleDotClick(index)}
                        sx={{ p: 0.5 }}
                    >
                        {index === currentSlide ?
                            <Circle fontSize="small" /> :
                            <CircleOutlined fontSize="small" />}
                    </IconButton>
                ))}
            </Stack>
        </Box>
    );
};

export default Home;